
import RolesModel from '../models/RolesModel'

export const adminLoadRoles = () => {
    return (dispatch) => {
        RolesModel.findAll((result) => {
            dispatch({type: 'ADMIN_ROLES_LOAD', items: result})
        })
    }
}

export const adminLoadRolesItem = (id) => {
    return (dispatch) => {
        if (!id) return dispatch(adminUpdateRolesForm(RolesModel.dispense()))
        RolesModel.find(id, (result) => {
            dispatch(adminUpdateRolesForm(result))
        })
    }
}

export const adminDelRolesItem = (item) => {
    return (dispatch) => {
        RolesModel.remove(item, (result) => {
            dispatch(adminLoadRoles())
        })
    }
}

export const adminStoreRolesItem = (formData) => {
    return (dispatch) => {
        RolesModel.store(formData, (result) => {
            if (result.item) formData['id'] = result.item.id
            dispatch(adminUpdateRolesForm(formData, true, result.error))
        })
    }
}

export const adminUpdateRolesForm = (formData, complete = false, error = '') => {
    return {
        type: 'ADMIN_UPDATE_ROLES_FORM',
        complete,
        error,
        formData
    }
}



// WEBPACK FOOTER //
// ./src/actions/adminRoles.js